import React from "react";
import SlashIcon from "../resources/slash.png";
import style from "./stylesheets/SlashHeader.module.scss";

const SlashHeader = ({children}) => {
    return (
        <div className={style.slash_header}>
            <img src={SlashIcon} alt="slash" />
            <h1>{children}</h1>
        </div>
    );
};

export default SlashHeader;
